import React, { useEffect, useState } from "react";
import { getAllImagesWithout } from ".";
import { isAuthenticated } from "../../Auth/helper";
import Header from "../../User/helper/Header";
import LoggedInNavbar from "./loggedInNavbar";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CircularProgress from "@mui/material/CircularProgress";
import LoginPrompt from "../../components/LoginPrompt"; 

const ShowImage = () => {
  const navigate = useNavigate();
  let [products, setAllProducts] = useState([]);
  let [mainCat, setMainCat] = useState([]);
  let [catThumbNail, setCatThumbNail] = useState([]);
  let [loading, setLoading] = useState(true);
  const [showPrompt, setShowPrompt] = useState(false); // NEW

  const checkSignedIn = (id, musicid, item) => {
    const isSignedin = isAuthenticated() && isAuthenticated().token && isAuthenticated().user?._id;
    if (isSignedin) {
      navigate(`/displaydata?way=${item}`);
    } else {
      setShowPrompt(true); // NEW
    }
  };

  useEffect(() => {
    const fetchdata = async () => {
      setLoading(true);
      try {
        await getAllImagesWithout().then((x) => {
          const getsubCategory = x.map((item) => item.subCategoryId);
          let uniqueObjArray = [...new Map(getsubCategory.map((item) => [item["subCategoryName"], item])).values()];
          setMainCat(uniqueObjArray.map((item) => item.subCategoryName));
          setCatThumbNail(uniqueObjArray.map((item) => item.subCategoryImageCDN));
          setAllProducts(x);
          setLoading(false);
        }).catch(() => setLoading(false));
      } catch { setLoading(false); }
    };
    fetchdata();
  }, []);

  const showCategory = (id) => {
    const isSignedin = isAuthenticated() && isAuthenticated().token && isAuthenticated().user?._id;
    if (isSignedin) {
      navigate(`/category/Images/${id}`);
    } else {
      setShowPrompt(true);
    }
  };

  return (
    <div>
      <LoginPrompt show={showPrompt} onClose={() => setShowPrompt(false)} />

      {isAuthenticated() && isAuthenticated().user?._id && isAuthenticated().token
        ? <LoggedInNavbar /> : <Header />}

      <div className="container" style={{ paddingTop: "80px" }}>
        <h2 style={{ color: "#E34607", lineHeight: "34px", padding: "20px" }}>Albums</h2>

        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }}>
            <CircularProgress color="warning" />
          </div>
        ) : mainCat.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 20px", color: "#888" }}>
            <p style={{ fontSize: 16 }}>No albums available at the moment.</p>
          </div>
        ) : (
          <center>
            <div className="container">
              <div className="row">
                {mainCat.map((item, index) => (
                  <div className="col-sm-3" style={{ padding: "5px" }} key={item}>
                    <center>
                      <div onClick={() => showCategory(item)} style={{ width: "18rem", cursor: "pointer" }}>
                        <LazyLoadImage src={catThumbNail[index]} alt={item} height="200" width="200" />
                        <p style={{ color: "#E34607", fontWeight: 500, marginTop: 8 }}>{item}</p>
                      </div>
                    </center>
                  </div>
                ))}
              </div>
            </div>
          </center>
        )}
        <br /><br />
      </div>
    </div>
  );
};

export default React.memo(ShowImage);